import http, { url } from '../../http'

const API_URL = "evaluation_providers"

class proveedoresEvaluacionAPI {

  async save(evaluation_providers) {
    const response = await http(`${API_URL}/save`, 'POST', evaluation_providers)
    return response
  }

  async saveEvaluacion(calification_evaluation_providers) {
    const response = await http(`calification_evaluation_providers/save`, 'POST', calification_evaluation_providers)
    return response
  }
 
  async getAll(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  } 

  async getAllSeleccion(idEvaluacion) {
    const response = await http(`calification_evaluation_providers/evaluation_all/${idEvaluacion}`)
    return response
  } 

  async getAllEvaluacionSeleccion(idEvaluacion, page, search) {
    const response = await http(`calification_evaluation_providers/index/${idEvaluacion}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getAllEvaluacion(page, search,companie_id) {
    const response = await http(`${API_URL}/index/${companie_id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getShow(idEvaluacion) {
    const response = await http(`${API_URL}/${idEvaluacion}`)
    return response
  } 

  async getShowC(idEvaluacion) {
    const response = await http(`calification_evaluation_providers/${idEvaluacion}`)
    return response
  } 

  async getFiles(id) {
    const response = await http(`identification_evaluation_files/${id}`, 'POST')
    return response
  } 

  async update(id, revision) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', revision)
    return response
  }

  async updateE(id, revision) {
    const response = await http(`calification_evaluation_providers/update/${id}`, 'PUT', revision)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  async deleteE(id) {
    const response = await http(`calification_evaluation_providers/delete/${id}`, 'DELETE')
    return response
  }
  
}

export default new proveedoresEvaluacionAPI()